var SelectedState = /* @__PURE__ */function (SelectedState2) {
  SelectedState2[SelectedState2["ACCEPTED"] = 0] = "ACCEPTED";
  SelectedState2[SelectedState2["DECLINED"] = 1] = "DECLINED";
  SelectedState2[SelectedState2["UNKNOWN"] = 2] = "UNKNOWN";
  return SelectedState2;
}(SelectedState || {});

export { SelectedState };